import { Switch, Route } from "react-router-dom";

import {
  ProductsList,
  ProductsPrices,
  ProductImageRedirect,
  ProductSearch,
  ProductSpecificationRedirect,
  ProductNew,
  ProductEdit,
  //
  ProductsManageList,
  ProductsManageEdit,
  //
  ProductGroupsList,
  ProductGroupEdit,
  ProductGroupNew,
  //
  PropertiesList,
  PropertiesEdit,
  PropertiesNew,
  //
  PrototypesList,
  PrototypesEdit,
  PrototypesNew,
  //
  PlatformTaxonsMain,
  PlatformTaxonsList,
  //
  RootTaxonsList,
  RootTaxonEdit,
  RootTaxonNew,
  //
  SettingsList,
  SettingsEdit,
  //
  WorkflowsList,
  //
  PlatformsList,
  PlatformsEdit,
  PlatformsNew,
  //
  ShopsList,
  ShopsEdit,
  ShopsNew,
  //
  ChannelsList,
  ChannelEdit,
  //
  ProducersList,
  ProducerEdit,
  ProducerNew,
  //
  BrandsList,
  BrandEdit,
  BrandNew,
  //
  VatRatesList,
  VatRateEdit,
  VatRateNew,
  //
  CurrenciesList,
  CurrencyEdit,
  CurrencyNew,
  // offers
  OffersEmptyList,
  //
  CampaignsList,
  //
  ChannelCampaignNew,
  ChannelCampaignEdit,
  //
  ChannelCampaignGroupNew,
  ChannelCampaignGroupEdit,
} from "../pages";

const Router = () => {
  return (
    <Switch>
      <Route exact={true} path="/products/search" component={ProductSearch} />
      <Route
        exact={true}
        path="/product_image_by_sku"
        component={ProductImageRedirect}
      />
      <Route
        exact={true}
        path="/product_specification_by_sku"
        component={ProductSpecificationRedirect}
      />
      <Route exact={true} path="/products" component={ProductsList} />
      <Route exact={true} path="/products/new" component={ProductNew} />
      <Route exact={true} path="/products/:id" component={ProductEdit} />

      <Route
        exact={true}
        path="/product_groups"
        component={ProductGroupsList}
      />
      <Route
        exact={true}
        path="/product_groups/new"
        component={ProductGroupNew}
      />
      <Route
        exact={true}
        path="/product_groups/:id"
        component={ProductGroupEdit}
      />

      <Route
        exact={true}
        path="/products_manage"
        component={ProductsManageList}
      />
      <Route
        exact={true}
        path={[
          "/products_manage/product_groups/:product_group_id/:tab/:type/:type_id*",
          "/products_manage/product_groups/:product_group_id/:tab/:type*",
          "/products_manage/product_groups/:product_group_id/:tab*",
        ]}
        component={ProductsManageEdit}
      />

      <Route exact={true} path="/properties" component={PropertiesList} />
      <Route exact={true} path="/properties/new" component={PropertiesNew} />
      <Route exact={true} path="/properties/:id" component={PropertiesEdit} />

      <Route exact={true} path="/prototypes" component={PrototypesList} />
      <Route exact={true} path="/prototypes/new" component={PrototypesNew} />
      <Route exact={true} path="/prototypes/:id" component={PrototypesEdit} />

      <Route exact={true} path="/root_taxons" component={RootTaxonsList} />
      <Route exact={true} path="/root_taxons/new" component={RootTaxonNew} />
      <Route exact={true} path="/root_taxons/:id" component={RootTaxonEdit} />

      <Route
        exact={true}
        path="/platforms/platform_taxons"
        component={PlatformTaxonsMain}
      />
      <Route
        exact={true}
        path="/platforms/:platform_id/platform_taxons"
        component={PlatformTaxonsList}
      />

      <Route exact={true} path="/platforms" component={PlatformsList} />
      <Route exact={true} path="/platforms/new" component={PlatformsNew} />
      <Route exact={true} path="/platforms/:id" component={PlatformsEdit} />

      <Route exact={true} path="/shops" component={ShopsList} />
      <Route exact={true} path="/shops/new" component={ShopsNew} />
      <Route exact={true} path="/shops/:id" component={ShopsEdit} />

      <Route exact={true} path="/channels" component={ChannelsList} />
      <Route exact={true} path="/channels/:id" component={ChannelEdit} />

      <Route exact={true} path="/settings" component={SettingsList} />

      <Route
        exact={true}
        path="/settings/:channel_type/:id"
        component={SettingsEdit}
      />
      <Route exact={true} path="/analyze" component={ProductsPrices} />

      <Route
        exact={true}
        path="/workflows/:progress_status*"
        component={WorkflowsList}
      />

      <Route exact={true} path="/producers" component={ProducersList} />
      <Route exact={true} path="/producers/new" component={ProducerNew} />
      <Route exact={true} path="/producers/:id" component={ProducerEdit} />

      <Route exact={true} path="/brands" component={BrandsList} />
      <Route exact={true} path="/brands/new" component={BrandNew} />
      <Route exact={true} path="/brands/:id" component={BrandEdit} />

      <Route exact={true} path="/vat_rates" component={VatRatesList} />
      <Route exact={true} path="/vat_rates/new" component={VatRateNew} />
      <Route exact={true} path="/vat_rates/:id" component={VatRateEdit} />

      <Route exact={true} path="/currencies" component={CurrenciesList} />
      <Route exact={true} path="/currencies/new" component={CurrencyNew} />
      <Route exact={true} path="/currencies/:id" component={CurrencyEdit} />

      <Route exact={true} path="/empty_offers" component={OffersEmptyList} />

      <Route
        exact={true}
        path="/campaigns/channels/:channel_id/channel_campaigns/new"
        component={ChannelCampaignNew}
      />

      <Route
        exact={true}
        path="/campaigns/channels/:channel_id/channel_campaigns/:channel_campaign_id"
        component={ChannelCampaignEdit}
      />

      <Route
        exact={true}
        path="/campaigns/channels/:channel_id/channel_campaigns/:channel_campaign_id/channel_campaign_groups/new"
        component={ChannelCampaignGroupNew}
      />
      <Route
        exact={true}
        path="/campaigns/channels/:channel_id/channel_campaigns/:channel_campaign_id/channel_campaign_groups/:channel_campaign_group_id"
        component={ChannelCampaignGroupEdit}
      />
      <Route exact={true} path="/campaigns" component={CampaignsList} />
      <Route
        exact={true}
        path="/campaigns/channels/:channel_id*"
        component={CampaignsList}
      />
    </Switch>
  );
};

export default Router;
